import store from './../store';
import errors, { parseError } from './errors';

export function httpRequestInterceptor(config) {
	const headers = config.headers;
	if (store.state.token) {
		headers.common.Authorization = `Bearer ${store.state.token}`;
		store.dispatch('toggleLoading', true);
	} else if (config.url === 'external-api/password/email' || config.url === 'external-api/password/reset'
		|| config.url === 'recruitment/detail-no-auth' || config.url === 'external-api/upload-file-applicant'
		|| config.url.startsWith('applicants-recruitment') || config.url.startsWith('temporary-token/detail')
		|| config.url.startsWith('certificates-applicant')) {
		store.dispatch('toggleLoading', true);
	} else {
		this.$router.push('login');
	}
	return config;
}

export function httpResponseSuccessInterceptor(response) {
	store.dispatch('toggleLoading', false);
	return response;
}

export function httpResponseInterceptor(error) {
	store.dispatch('toggleLoading', false);

	// Manejo mejorado de errores con mensajes específicos
	const loginRoute = { name: 'login' };
	const status = error.response && error.response.status;
	const parsedError = parseError(error);

	let text = 'Ocurrió un error inesperado.';

	if (status === 401 && this.$route.name !== 'reset-password') {
		// Mantener lógica original de redirección para 401
		text = 'Su sesión expiró.';
		this.$router.push(loginRoute);
	} else if (status === 400) {
		// Usar nueva función de errores para mensajes específicos
		text = errors(error.response);
	} else if (status === 403) {
		text = 'No tiene suficientes permisos para realizar ésta acción.';
	} else if (status === 404) {
		text = 'El recurso solicitado no existe.';
	} else if (status === 422) {
		// Error de validación - mostrar mensaje específico
		text = errors(error.response);
	} else if (status === 500) {
		text = 'No se logró completar la acción. Por favor intente nuevamente.';
	} else if (status === 502 || status === 503 || status === 504) {
		text = 'El servidor no está disponible. Por favor intente más tarde.';
	} else if (!status) {
		// Error de red/conexión
		text = 'Error de conexión. Por favor verifique su conexión a internet.';
	} else {
		// Para otros códigos de estado, intentar usar mensaje del servidor
		text = parsedError.message || text;
	}

	store.dispatch('showSnackBar', { text, color: 'error' });

	// Log en consola para debugging (opcional en desarrollo)
	if (process.env.NODE_ENV === 'development') {
		/* eslint-disable no-console */
		console.error('HTTP Error:', {
			status,
			message: text,
			details: parsedError.details,
			code: parsedError.code,
			error,
		});
		/* eslint-enable no-console */
	}

	// Mantener error.response para compatibilidad con componentes que acceden error.data/error.status
	return Promise.reject(error.response);
}



// WEBPACK FOOTER //
// ./src/http/index.js